import type { NavigationGuard } from 'vue-router';

import {
  MASTER_DATA_OBJECTS,
  CPQ_CONFIGURATION_DATA_OBJECTS,
  ADVANCED_APPROVALS_CPQ_CONFIGURATION_DATA_OBJECTS,
  BILLING_CPQ_CONFIGURATION_DATA_OBJECTS,
} from '../../config';
import {
  isAdvancedApprovalsSupported,
  isBillingSupported,
} from '../../composables/useConnections';
import { indexArray } from '../../util';

const MASTER_DATA_OBJECTS_BY_KEY = indexArray(MASTER_DATA_OBJECTS);
const CPQ_CONFIGURATION_DATA_OBJECTS_BY_KEY = indexArray(
  CPQ_CONFIGURATION_DATA_OBJECTS
);
const ADVANCED_APPROVALS_CPQ_CONFIGURATION_DATA_OBJECTS_BY_KEY = indexArray(
  ADVANCED_APPROVALS_CPQ_CONFIGURATION_DATA_OBJECTS
);
const BILLING_CPQ_CONFIGURATION_DATA_OBJECTS_BY_KEY = indexArray(
  BILLING_CPQ_CONFIGURATION_DATA_OBJECTS
);

function isSupportedSobject(sobject: string): boolean {
  return (
    MASTER_DATA_OBJECTS_BY_KEY[sobject] !== undefined ||
    CPQ_CONFIGURATION_DATA_OBJECTS_BY_KEY[sobject] !== undefined ||
    ADVANCED_APPROVALS_CPQ_CONFIGURATION_DATA_OBJECTS_BY_KEY[sobject] !==
      undefined ||
    BILLING_CPQ_CONFIGURATION_DATA_OBJECTS_BY_KEY[sobject] !== undefined
  );
}

const supportedSobjectGuard: NavigationGuard = async (to, __, next) => {
  const { sobject } = to.query;

  if (typeof sobject !== 'string') {
    return next('/');
  }

  if (isSupportedSobject(sobject) === false) {
    return next('/');
  }

  if (
    ADVANCED_APPROVALS_CPQ_CONFIGURATION_DATA_OBJECTS_BY_KEY[sobject] &&
    isAdvancedApprovalsSupported.value === false
  ) {
    return next('/');
  }

  if (
    BILLING_CPQ_CONFIGURATION_DATA_OBJECTS_BY_KEY[sobject] &&
    isBillingSupported.value === false
  ) {
    return next('/');
  }

  return next();
};

export default supportedSobjectGuard;
